import { createApiSlice } from "@common";
import { LMS_LEAVE_ELIGIBILITY } from "@routes";

const apiConfig = [
  {
    name: "addLeaveEligibilityMain",
    method: "post",
    url: LMS_LEAVE_ELIGIBILITY,
    stateKey: "message"
  },
  
  {
    name: "getLeaveEligibilityMain",
    method: "get",
    url: LMS_LEAVE_ELIGIBILITY,
    stateKey: "data"
  },
  {
    name: "updateLeaveEligibilityMain",
    method: "put",
    url: LMS_LEAVE_ELIGIBILITY,
    stateKey: "message"
  },
  {
    name: "deleteLeaveEligibilityMain",
    method: "delete",
    url: LMS_LEAVE_ELIGIBILITY,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: []
  },
  reducers: {
    setAdditionalData: (state, action) => { state.additionalData = action.payload; },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "LeaveEligibilityMain",
  apiConfig,
  customReducers
);
const LeaveEligibilityMainSlice = slice;

export default LeaveEligibilityMainSlice.reducer;

export const {
  addLeaveEligibilityMain,
  getLeaveEligibilityMain,
 
  updateLeaveEligibilityMain,
  deleteLeaveEligibilityMain
} = thunks;
export const { rowSelect } = actions;
